export const TeacherValidation = (
  name: string,
  value: string,
  formData: any
): string => {
  switch (name) {
    case "first_name":
      if (value.trim() === "") return "First name should not be empty";
      if (value.length < 3)
        return "First name should be greater than 3 characters";
      break;
    case "last_name":
      if (value.trim() === "") return "Last name should not be empty";
      break;
    case "address":
      if (value.trim() === "") return "Address should not be empty";
      break;
    case "phone_number":
      const phonePattern = /^[0-9]{7,10}$/;
      // const phonePattern = /^\(\d{3}\)\s?\d{3}-\d{4}$/;
      if (!phonePattern.test(value)) return "Phone number should be 10 digits";
      break;
    case "email":
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailPattern.test(value)) return "Invalid email address";
      break;
    case "password":
      if (value.trim() === "") return "Password should not be empty";
      if (value.length < 6) return "Password should be at least 6 characters";
      break;
    case "confirm_password":
      if (value !== formData.password) return "Passwords do not match";
      break;
    default:
      break;
  }
  return "";
};
